import { render, staticRenderFns } from "./ServicesCard.vue?vue&type=template&id=ce8f8210&scoped=true"
import script from "./ServicesCard.vue?vue&type=script&lang=js"
export * from "./ServicesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8f8210",
  null
  
)

export default component.exports